import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-workflow-web/';
export default {
  axios,
  worklist(params) { // 审核列表
    return axios.get(`${baseUrl}work/list?${utils.exchangeParams(params)}`);
  },
  myWorklist(params) { // 我的审核列表
    return axios.get(`${baseUrl}work/apply/list?${utils.exchangeParams(params)}`);
  },
  relatedWorklist(params) { // 相关审批列表
    return axios.get(`${baseUrl}work/accountant/list?${utils.exchangeParams(params)}`);
  },
  bussinessTypes() { // 获取业务类型
    return axios.get(`${baseUrl}work/listBusinessType`);
  },
  operateIdea(params) { // 提交审核意见
    return axios.post(`${baseUrl}work/operate`, utils.exchangeParams(params));
  },
  approveSteps(params) { // 审核步骤
    return axios.get(`${baseUrl}work/flowInfo?${utils.exchangeParams(params)}`);
  },
  /* 运营工具 审批管理 */
  getWorkflowList(params) { // 审批流列表
    return axios.get(`${baseUrl}manage/work/list?${utils.exchangeParams(params)}`);
  },
  getWorkflowCheckName(params) { // 检查名称是否重复
    return axios.get(`${baseUrl}manage/work/checkName?${utils.exchangeParams(params)}`);
  },
  workflowSave(params) { // 新建审批流
    return axios.post(`${baseUrl}manage/work/save`, utils.exchangeParams(params));
  },
  workflowUpdate(params) { // 更新审批流
    return axios.post(`${baseUrl}manage/work/update`, utils.exchangeParams(params));
  },
  getWorkflowInfo(params) { // 查看审批流
    return axios.get(`${baseUrl}manage/work/info?${utils.exchangeParams(params)}`);
  },
  setWorkflowStatusEnable(params) { // 启用审批流
    return axios.post(`${baseUrl}manage/work/enable`, utils.exchangeParams(params));
  },
  setWorkflowStatusDisable(params) { // 禁用审批流
    return axios.post(`${baseUrl}manage/work/disable`, utils.exchangeParams(params));
  },
  getWorkflowListRecord(params) { // 查询未结束审批流列表
    return axios.get(`${baseUrl}manage/work/listRecord?${utils.exchangeParams(params)}`);
  },
  operateCreditInfo(params) { // 提交信誉意见
    return axios.post('v1/erp-base-web/supplier/store/updateQualityOpinions', utils.exchangeParams(params));
  },
  exportWorkRecord(params) { // 导出审批单
    return axios.post('/v1/erp-business-web/workLog/work/record/export', utils.exchangeParams(params));
  },
};
